import React from "react"
import Icon from "../../Icon/Icon"
import Button from "../../Button/Button"
import {JWTProviders} from "../../../resources/orgSettings"
import {useModal} from "react-modal-hook"
import {JwksInfoModal} from "../JwksInfoModal/JwksInfoModal"

export default function OktaFields({
	jwksPath,
	jwtIssuer,
	updateSettings,
	provider,
}: {
	jwksPath: string
	jwtIssuer: string | undefined
	updateSettings: (field: string, value: string) => void
	provider: JWTProviders
}) {
	const [showJwksInfoModal, hideJwksInfoModal] = useModal(() => (
		<JwksInfoModal close={hideJwksInfoModal} provider={provider} />
	))

	return (
		<fieldset className="fields">
			<div className="field">
				<div className="label-wrapper label-with-help">
					<label className="label">JWKS Path</label>
					<div className="help-elements">
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<Button type="button" className="jwks-button" onClick={showJwksInfoModal}>
							How to find my JWKS
						</Button>
					</div>
				</div>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Your JWKS Key"
						value={jwksPath ?? ""}
						pattern="https:\/\/([A-Za-z0-9\-]+\.)+okta\.com\/oauth2\/[A-Za-z0-9]+\/v1\/keys"
						onChange={(e) => {
							updateSettings("jwksPath", e.target.value)
							if (e.target.validity.patternMismatch) {
								e.target.setCustomValidity(
									"invalid url, make sure your url is in this format: 'https://{oktaDomain}/oauth2/{authorization_server_id}/v1/keys'"
								)
							} else {
								e.target.setCustomValidity("")
							}
						}}
					/>
				</div>
			</div>
			<div className="field">
				<label className="label">JWT Issuer</label>
				<div className="control">
					<input
						className="input"
						type="text"
						value={jwtIssuer ?? ""}
						placeholder="Issuer"
						onChange={(e) => {
							updateSettings("jwtIssuer", e.target.value)
						}}
					/>
				</div>
			</div>
		</fieldset>
	)
}
